export enum ApplicationLayout {
  default = 'default-app-layout',
  login = 'login-app-layout'
}
